<div class="ca-results">
	<div class="ca-toast" role="alert" *ngIf="vm.documentErrorKey">{{ vm.documentErrorKey | translate }}</div>
	<div class="ca-wrap" *ngIf="vm.loading">
		<div class="ca-card ca-pad">{{ 'Compliance_Assessment.Results_Loading' | translate }}</div>
	</div>

	<div class="ca-wrap" *ngIf="!vm.loading && vm.error">
		<div class="ca-card ca-pad">
			<h1 class="ca-title">{{ 'Compliance_Assessment.Results_Unavailable_Title' | translate }}</h1>
			<p class="ca-muted" style="margin-top: 10px;">{{ 'Compliance_Assessment.Results_Unavailable_Message' | translate }}</p>
			<button type="button" class="ca-btn ca-btn-ghost" style="margin-top: 14px;" (click)="vm.back()">{{ 'Common.Back' | translate }}</button>
		</div>
	</div>

	<div class="ca-wrap" *ngIf="!vm.loading && !vm.error">
		<div class="ca-top">
			<div>
				<div class="ca-eyebrow">{{ vm.summary?.survey?.groupName || ('Compliance_Assessment.Title' | translate) }}</div>
				<h1 class="ca-title">{{ (vm.actionPlanOnly ? 'Compliance_Assessment.Action_Planning_Title' : 'Compliance_Assessment.Results_Title') | translate }}</h1>
			</div>
			<div style="display:flex; gap:8px; flex-wrap:wrap; justify-content:flex-end;">
				<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" (click)="vm.back()">{{ 'Common.Back' | translate }}</button>
				<span class="ca-chip ca-chip-brand">{{ vm.summary?.survey?.status || ('Compliance_Assessment.Status_Unavailable' | translate) }}</span>
			</div>
		</div>

		<ng-container *ngIf="!vm.actionPlanOnly && vm.resultsViewMode === 'results'">
		<div class="ca-banner warn" *ngIf="vm.responseRate < vm.credibleResponseRate">
			<div><b>{{ 'Compliance_Assessment.Low_Response_Title' | translate }}</b> {{ 'Compliance_Assessment.Low_Response_Message' | translate }}</div>
		</div>

		<div class="ca-stats">
			<div class="ca-card ca-stat">
				<div class="big">{{ vm.responseRate }}%</div>
				<div class="label">{{ 'Compliance_Assessment.Response_Rate' | translate }}</div>
				<div class="ca-meter"><i [style.width.%]="vm.responseRate"></i><span class="threshold"></span></div>
				<div class="ca-small ca-muted" style="margin-top:8px;">{{ (vm.responseRate >= vm.credibleResponseRate ? 'Compliance_Assessment.Above_Threshold' : 'Compliance_Assessment.Below_Threshold') | translate }}</div>
			</div>
			<div class="ca-card ca-stat">
				<div class="big">{{ vm.respondedCount || 0 }} <span style="font-size:1rem;color:#8a938b;font-weight:600">/ {{ vm.sentCount || 0 }}</span></div>
				<div class="label">{{ 'Compliance_Assessment.Responded_Invited' | translate }}</div>
				<div class="ca-small ca-muted" style="margin-top:8px;">{{ 'Compliance_Assessment.Survey_Participation' | translate }}</div>
			</div>
			<div class="ca-card ca-stat">
				<div class="big">{{ vm.reportableRows || 0 }}</div>
				<div class="label">{{ 'Compliance_Assessment.Reportable_Rows' | translate }}</div>
				<div class="ca-small ca-muted" style="margin-top:8px;">{{ 'Compliance_Assessment.Reportable_Rows_Hint' | translate }}</div>
			</div>
			<div class="ca-card ca-stat">
				<div class="big">{{ vm.priorities?.length || 0 }}</div>
				<div class="label">{{ 'Compliance_Assessment.Moderate_High_Critical_Risks' | translate }}</div>
				<div class="ca-small ca-muted" style="margin-top:8px;">{{ 'Compliance_Assessment.Preselected_For_Action_Planning' | translate }}</div>
			</div>
		</div>

		<div class="ca-section-title">
			<div style="display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;">
				<h2>{{ 'Compliance_Assessment.Psychosocial_Risks' | translate }}</h2>
				<span class="ca-chip">{{ 'Compliance_Assessment.Sorted_By_Risk_Level' | translate }}</span>
			</div>
			<label class="ca-cmp-field">
				<span class="ca-cmp-label">{{ 'Compliance_Assessment.Compare' | translate }}</span>
				<select [(ngModel)]="vm.compareId" (ngModelChange)="vm.loadComparison()" [disabled]="vm.comparisonListLoading || vm.comparisonListError" [attr.aria-label]="'Compliance_Assessment.Compare_Previous_Survey' | translate">
					<option *ngFor="let option of vm.compareOptions" [ngValue]="option.id">{{ option.label }}</option>
				</select>
			</label>
		</div>
		<p class="ca-small ca-muted" *ngIf="vm.comparisonListLoading || vm.comparisonLoading" role="status">{{ 'Toolkit.Common.Loading' | translate }}</p>
		<p class="ca-small ca-muted" *ngIf="!vm.comparisonListLoading && !vm.comparisonListError && vm.compareOptions?.length === 1">{{ 'Compliance_Assessment.Compare_No_Previous' | translate }}</p>
		<div class="ca-banner warn" *ngIf="vm.comparisonListError || vm.comparisonError" role="alert">
			<div>{{ 'Compliance_Assessment.Compare_Error' | translate }} <button type="button" class="ca-link-button" (click)="vm.retryComparison()">{{ 'Compliance_Assessment.Compare_Retry' | translate }}</button></div>
		</div>
		<div class="ca-banner info" *ngIf="vm.compareId && !vm.comparisonLoading && !vm.comparisonError">
			<div>{{ 'Compliance_Assessment.Compare_Info' | translate }} <b>{{ vm.compareLabel() }}</b>. {{ 'Compliance_Assessment.Compare_Markers_Hint' | translate }}</div>
		</div>
		<div class="ca-card ca-risk-table">
			<div class="ca-risk-head">
				<span>{{ 'Compliance_Assessment.Risk_Area' | translate }}</span>
				<span>{{ 'Compliance_Assessment.Company_Score_Vs_Reference' | translate }}<ng-container *ngIf="vm.compareId"> · {{ 'Compliance_Assessment.Previous' | translate }}</ng-container></span>
				<span>{{ (vm.compareId ? 'Compliance_Assessment.Status_Change' : 'Compliance_Assessment.Status') | translate }}</span>
			</div>
			<div class="ca-risk-row" *ngFor="let risk of vm.risks" (click)="vm.openRisk(risk)">
				<div class="ca-risk-name">{{ risk.nameKey | translate }}<small>{{ risk.source }} · {{ risk.descKey | translate }}</small></div>
				<div class="ca-scoreviz">
					<div class="bar">
						<i [ngClass]="vm.riskClass(risk.riskLevel)" [style.width.%]="vm.scoreWidth(risk)"></i>
						<span class="tick" [style.left.%]="vm.benchmarkLeft(risk)"></span>
						<span class="tick prev" *ngIf="vm.hasCompareScore(risk)" [style.left.%]="vm.previousLeft(risk)" [attr.title]="vm.previousLabel(risk)"></span>
					</div>
					<div class="nums">
						<span class="sc" [ngClass]="{'exposure': risk.exposure, 'not-reportable': risk.averageScore === null || risk.averageScore === undefined}">{{ risk.averageScore !== null && risk.averageScore !== undefined ? vm.scoreLabel(risk) : ('Compliance_Assessment.Not_Reportable' | translate) }}</span>
						<span class="pv" *ngIf="vm.hasCompareScore(risk)">{{ vm.previousLabel(risk) }}</span>
						<span class="rf">{{ vm.referenceLabel(risk) }}</span>
					</div>
				</div>
				<div class="ca-risk-status">
					<span class="ca-rl" [ngClass]="vm.riskClass(risk.riskLevel)">{{ vm.riskLevelLabel(risk.riskLevel) | translate }}</span>
					<span class="ca-trend" *ngIf="vm.hasCompareScore(risk)" [attr.title]="vm.previousLabel(risk)" [ngClass]="vm.compareChangeClass(risk)">{{ vm.compareChangeLabel(risk) }}</span>
					<span class="ca-small ca-muted" *ngIf="vm.compareId && !vm.comparisonLoading && !vm.comparisonError && !vm.hasCompareScore(risk)">{{ 'Compliance_Assessment.Compare_Score_Unavailable' | translate }}</span>
				</div>
			</div>
			<div class="ca-pad ca-muted" *ngIf="!vm.risks?.length">{{ 'Compliance_Assessment.No_Reportable_Risks' | translate }}</div>
		</div>

		<div class="ca-modal-backdrop" *ngIf="vm.selectedRisk" (click)="vm.closeRisk()">
			<div class="ca-drawer" (click)="$event.stopPropagation()">
				<div class="ca-drawer-head">
					<div>
						<h3>{{ vm.selectedRisk.nameKey | translate }}</h3>
						<div class="ca-small ca-muted">{{ vm.selectedRisk.source }} · {{ vm.selectedRisk.descKey | translate }}</div>
						<div style="margin-top:8px;"><span class="ca-rl" [ngClass]="vm.riskClass(vm.selectedRisk.riskLevel)">{{ vm.riskLevelLabel(vm.selectedRisk.riskLevel) | translate }}</span></div>
					</div>
					<button type="button" class="ca-close" (click)="vm.closeRisk()">×</button>
				</div>
				<div class="ca-drawer-body">
						<p class="ca-muted">
							{{ vm.selectedRisk.descKey | translate }}
							<span *ngIf="vm.selectedRisk.averageScore !== null && vm.selectedRisk.averageScore !== undefined">
								{{ (vm.selectedRisk.exposure ? 'Compliance_Assessment.Exposure' : 'Compliance_Assessment.Company_Score') | translate }} {{ vm.scoreLabel(vm.selectedRisk) }} · {{ vm.referenceLabel(vm.selectedRisk) }}.
							</span>
						</p>
						<div class="ca-banner warn" *ngIf="vm.selectedRisk.confidentialActionRequired">
							<div><b>{{ 'Compliance_Assessment.Confidential_Action_Required_Title' | translate }}</b> {{ 'Compliance_Assessment.Confidential_Action_Required_Message' | translate }}</div>
						</div>

						<h3>{{ 'Compliance_Assessment.Score_By_Team' | translate }}</h3>
					<table class="ca-mini-table">
						<thead>
							<tr><th>{{ 'Compliance_Assessment.Team' | translate }}</th><th>{{ 'Compliance_Assessment.Score' | translate }}</th><th>{{ 'Compliance_Assessment.Level' | translate }}</th></tr>
						</thead>
						<tbody>
							<tr *ngFor="let row of vm.selectedRisk.details?.scoreByTeam">
								<td>{{ row.team }}</td>
								<td *ngIf="!row.suppressed">{{ row.score !== null && row.score !== undefined ? (vm.selectedRisk.exposure ? (row.score + '%') : row.score) : '—' }}</td>
								<td *ngIf="!row.suppressed"><span class="ca-rl" [ngClass]="vm.riskClass(row.riskLevel)">{{ vm.riskLevelLabel(row.riskLevel) | translate }}</span></td>
								<td *ngIf="row.suppressed" colspan="2" class="ca-suppress">— ({{ 'Compliance_Assessment.Below_Reporting_Minimum' | translate }})</td>
							</tr>
							<tr *ngIf="!vm.selectedRisk.details?.scoreByTeam?.length"><td colspan="3" class="ca-muted">{{ 'Compliance_Assessment.No_Team_Breakdown' | translate }}</td></tr>
						</tbody>
					</table>

					<h3 style="margin-top:20px;">{{ 'Compliance_Assessment.Response_Distribution' | translate }}</h3>
					<div class="ca-dist" *ngFor="let dist of vm.selectedRisk.details?.responseDistribution">
						<div class="ca-dist-title">{{ dist.question }}</div>
						<div class="ca-dist-row" *ngFor="let option of dist.options">
							<div class="ca-dist-label"><span>{{ option.label }}</span><span>{{ option.percent }}%</span></div>
							<div class="ca-dist-bar"><i [style.width.%]="option.percent"></i></div>
						</div>
						</div>
						<div class="ca-muted" *ngIf="!vm.selectedRisk.details?.responseDistribution?.length">{{ 'Compliance_Assessment.No_Response_Distribution' | translate }}</div>

						<div class="ca-pulse-card" *ngIf="vm.shouldShowPulse(vm.selectedRisk)">
							<h4>{{ 'Compliance_Assessment.Remeasure_Risk' | translate }}</h4>
							<p class="ca-small">
								{{ 'Compliance_Assessment.Pulse_Card_Text_Start' | translate }} <b>{{ vm.selectedRisk.nameKey | translate }}</b>
								({{ vm.pulseQuestionCount(vm.selectedRisk) }} {{ (vm.pulseQuestionCount(vm.selectedRisk) === 1 ? 'Compliance_Assessment.Question_Singular' : 'Compliance_Assessment.Question_Plural') | translate }})
								{{ 'Compliance_Assessment.Pulse_Card_Text_End' | translate }}
							</p>
							<button type="button" class="ca-btn ca-btn-purple ca-btn-sm" style="margin-top:12px;" (click)="vm.launchPulseSurvey(vm.selectedRisk)">{{ 'Compliance_Assessment.Launch_Pulse_Survey' | translate }}</button>
						</div>

						<h3 style="margin-top:20px;">{{ 'Compliance_Assessment.Recommended_Organisational_Responses' | translate }}</h3>
						<div class="ca-suggest" *ngFor="let control of vm.recommendedControls(vm.selectedRisk)">
						<div class="t">{{ vm.actionTitle(control) }}</div>
						<div class="ca-small ca-muted" style="margin-top:4px;">{{ vm.actionDescription(control) }}</div>
						<span class="ca-chip ca-chip-brand" style="margin-top:8px;">{{ 'Compliance_Assessment.Organisational' | translate }}</span>
					</div>
				</div>
			</div>
		</div>
		<div class="ca-card ca-pad" style="margin-top:22px; display:flex; justify-content:space-between; align-items:center; gap:14px; flex-wrap:wrap;">
			<div>
				<h3 style="margin:0;">{{ (vm.planCompleted ? 'Compliance_Assessment.Action_Plan_Completed_Title' : 'Compliance_Assessment.Start_Action_Planning') | translate }}</h3>
				<p class="ca-small ca-muted" style="margin:4px 0 0;">{{ (vm.planCompleted ? 'Compliance_Assessment.Action_Plan_Completed_Hint' : 'Compliance_Assessment.Start_Action_Planning_Hint') | translate }}</p>
			</div>
			<div class="ca-result-actions">
				<button type="button" class="ca-btn ca-btn-ghost" *ngIf="vm.planCompleted" (click)="vm.viewComplianceRecord()">{{ 'Compliance_Assessment.View_Compliance_Record' | translate }}</button>
				<a class="ca-btn ca-btn-primary" *ngIf="!vm.planCompleted" [routerLink]="['/compliance', vm.questionnaireRequestId, 'action-plan']">{{ 'Compliance_Assessment.Start_Action_Planning_Button' | translate }}</a>
				<button type="button" class="ca-btn ca-btn-primary" *ngIf="vm.planCompleted" (click)="vm.reviewActionPlan()">{{ 'Compliance_Assessment.Review_Action_Plan' | translate }} <span class="ca-chip" style="background:rgba(255,255,255,.25);color:#fff;border:0">{{ vm.priorities?.length || 0 }} {{ 'Compliance_Assessment.Priority' | translate }}</span></button>
			</div>
		</div>
		</ng-container>

		<div class="ca-record-wrap" *ngIf="!vm.actionPlanOnly && vm.resultsViewMode === 'record'">
			<div class="ca-footer-actions" style="margin:0 0 14px;">
				<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" (click)="vm.back()">{{ 'Common.Back' | translate }}</button>
				<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" (click)="vm.printPage()">{{ 'Compliance_Assessment.Print_Save_Pdf' | translate }}</button>
			</div>
			<div class="ca-record-hero">
				<div class="ca-small" style="opacity:.9;">{{ 'Compliance_Assessment.Compliance_Record' | translate }}</div>
				<h1 class="ca-title" style="margin-top:10px;">{{ 'Compliance_Assessment.Record_Title' | translate }}</h1>
				<p style="opacity:.92;margin:6px 0 0;">{{ vm.summary?.survey?.groupName || ('Compliance_Assessment.The_Organisation' | translate) }} · {{ vm.assessmentDate() | date:'dd MMM yyyy' }} · {{ 'Compliance_Assessment.Completed' | translate }}</p>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Conducted' | translate }}</h2></div>
				<div class="ca-summary-grid">
					<div><div class="k">{{ 'Compliance_Assessment.Organisation' | translate }}</div><b>{{ vm.summary?.survey?.groupName || ('Compliance_Assessment.The_Organisation' | translate) }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Assessment_Date' | translate }}</div><b>{{ vm.assessmentDate() | date:'dd MMM yyyy' }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Method' | translate }}</div><b>{{ 'Compliance_Assessment.Method_Copsoq_Digital' | translate }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Response_Rate' | translate }}</div><b>{{ vm.responseRate }}% ({{ vm.respondedCount || 0 }}/{{ vm.sentCount || 0 }})</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Reportable_Rows' | translate }}</div><b>{{ vm.reportableRows || 0 }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Next_Review' | translate }}</div><b>{{ vm.nextReviewDate() | date:'dd MMM yyyy' }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Next_Annual_Assessment' | translate }}</div><b>{{ vm.nextAnnualAssessmentDate() | date:'dd MMM yyyy' }}</b></div>
				</div>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Legal_Basis' | translate }}</h2></div>
				<p class="ca-small ca-muted" style="margin-top:-6px;">{{ 'Compliance_Assessment.Legal_Basis_Record_Hint' | translate }}</p>
				<table class="ca-table">
					<tbody>
						<tr *ngFor="let row of vm.complianceRecord.legalBasisRows">
							<td style="white-space:nowrap;"><b>{{ row.titleKey | translate }}</b></td>
							<td>{{ row.textKey | translate }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Risk_Results' | translate }}</h2></div>
				<div style="display:flex; gap:8px; flex-wrap:wrap; margin-bottom:10px;">
					<span class="ca-rl critical">{{ 'Compliance_Assessment.Risk_Critical' | translate }}: {{ vm.complianceRecord.riskLevelCounts.critical }}</span>
					<span class="ca-rl high">{{ 'Compliance_Assessment.Risk_High' | translate }}: {{ vm.complianceRecord.riskLevelCounts.high }}</span>
					<span class="ca-rl moderate">{{ 'Compliance_Assessment.Risk_Moderate' | translate }}: {{ vm.complianceRecord.riskLevelCounts.moderate }}</span>
					<span class="ca-rl low">{{ 'Compliance_Assessment.Risk_Low' | translate }}: {{ vm.complianceRecord.riskLevelCounts.low }}</span>
				</div>
				<table class="ca-table">
					<thead><tr><th>{{ 'Compliance_Assessment.Risk_Area' | translate }}</th><th>{{ 'Compliance_Assessment.Company' | translate }}</th><th>{{ 'Compliance_Assessment.Reference' | translate }}</th><th>{{ 'Compliance_Assessment.Status' | translate }}</th></tr></thead>
					<tbody>
						<tr *ngFor="let risk of vm.risks">
							<td><b>{{ risk.nameKey | translate }}</b><small style="display:block;" class="ca-muted">{{ risk.source }}</small></td>
							<td>{{ vm.scoreLabel(risk) }}</td>
							<td>{{ vm.referenceLabel(risk) }}</td>
							<td><span class="ca-rl" [ngClass]="vm.riskClass(risk.riskLevel)">{{ vm.riskLevelLabel(risk.riskLevel) | translate }}</span></td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Risks_Requiring_Action' | translate }}</h2></div>
				<div style="display:flex; gap:8px; flex-wrap:wrap;" *ngIf="vm.complianceRecord.includedPriorityRisks.length; else noPriorityRisks">
					<span class="ca-chip" *ngFor="let risk of vm.complianceRecord.includedPriorityRisks">{{ risk.nameKey ? (risk.nameKey | translate) : vm.riskDisplayName(risk) }} · {{ vm.riskLevelLabel(risk.riskLevel) | translate }}</span>
				</div>
				<ng-template #noPriorityRisks><p class="ca-muted">{{ 'Compliance_Assessment.No_Control_Selected' | translate }}</p></ng-template>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Participation' | translate }}</h2></div>
				<p class="ca-small ca-muted" style="margin-top:-6px;">{{ 'Compliance_Assessment.Worker_Consultation_Record_Hint' | translate }}</p>
				<table class="ca-table">
					<tbody>
						<tr><td>{{ 'Compliance_Assessment.Respondents' | translate }}</td><td>{{ vm.respondedCount || 0 }} / {{ vm.sentCount || 0 }} ({{ vm.responseRate }}%), {{ 'Compliance_Assessment.Anonymous' | translate }}</td></tr>
						<tr><td>{{ 'Compliance_Assessment.Worker_Representative' | translate }}</td><td>{{ vm.complianceRecord.workerConsultationLabel }}</td></tr>
						<tr><td>{{ 'Compliance_Assessment.Actions_Assigned' | translate }}</td><td>{{ vm.complianceRecord.actionCount }} · {{ vm.complianceRecord.doneCount }} {{ 'Compliance_Assessment.Done' | translate }}</td></tr>
					</tbody>
				</table>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Differentiated_Analysis' | translate }}</h2></div>
				<p class="ca-small ca-muted" style="margin-top:-6px;">{{ 'Compliance_Assessment.Differentiated_Analysis_Record_Hint' | translate }}</p>
				<table class="ca-table">
					<thead><tr><th>{{ 'Compliance_Assessment.Team' | translate }}</th><th>{{ 'Compliance_Assessment.Respondents' | translate }}</th></tr></thead>
					<tbody>
						<tr *ngFor="let row of vm.complianceRecord.teamParticipationRows">
							<td>{{ row.name }}</td>
							<td>{{ row.suppressed ? ('— (' + ('Compliance_Assessment.Below_Reporting_Minimum' | translate) + ')') : row.responded }}</td>
						</tr>
					</tbody>
				</table>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;">
					<h2>{{ 'Compliance_Assessment.Record_Section_Action_Plan' | translate }}</h2>
					<span class="ca-chip ca-chip-brand">{{ vm.complianceRecord.doneCount }} / {{ vm.complianceRecord.actionCount }} {{ 'Compliance_Assessment.Done' | translate }}</span>
				</div>
				<p class="ca-small ca-muted" style="margin-top:-6px;">{{ 'Compliance_Assessment.Action_Plan_Prevention_Hint' | translate }}</p>
				<div style="margin:12px 0;" *ngFor="let section of vm.complianceRecord.actionSections">
					<h3 style="margin:0 0 8px;">{{ section.risk.nameKey ? (section.risk.nameKey | translate) : vm.riskDisplayName(section.risk) }}</h3>
					<table class="ca-table ca-action-plan-table">
						<colgroup>
							<col class="ca-action-plan-table__control">
							<col class="ca-action-plan-table__owner">
							<col class="ca-action-plan-table__due">
							<col class="ca-action-plan-table__status">
						</colgroup>
						<thead><tr><th>{{ 'Compliance_Assessment.Control' | translate }}</th><th>{{ 'Compliance_Assessment.Owner' | translate }}</th><th>{{ 'Compliance_Assessment.Due' | translate }}</th><th>{{ 'Compliance_Assessment.Status' | translate }}</th></tr></thead>
						<tbody>
							<tr *ngFor="let action of section.actions">
								<td [attr.data-label]="'Compliance_Assessment.Control' | translate">
									<button type="button" *ngIf="vm.canOpenActionDetails(action); else recordPlainControl" class="ca-link-button completed" (click)="vm.openActionDetail(action)">
										{{ vm.actionTitle(action) }}<span *ngIf="action.done"> ✓</span>
									</button>
									<ng-template #recordPlainControl>{{ vm.actionTitle(action) }}<span *ngIf="action.done"> ✓</span></ng-template>
								</td>
								<td [attr.data-label]="'Compliance_Assessment.Owner' | translate">{{ vm.employeeName(action.owner) || ('Compliance_Assessment.TBC' | translate) }}</td>
								<td [attr.data-label]="'Compliance_Assessment.Due' | translate">{{ action.cutOffDate | date:'dd MMM yyyy' }}</td>
								<td [attr.data-label]="'Compliance_Assessment.Status' | translate"><span class="ca-rl" [ngClass]="vm.actionStatus(action).className">{{ vm.actionStatus(action).labelKey | translate }}</span></td>
							</tr>
							<tr *ngIf="!section.actions.length"><td colspan="4" class="ca-muted ca-action-plan-table__empty">{{ 'Compliance_Assessment.No_Control_Selected' | translate }}</td></tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Data_Protection' | translate }}</h2></div>
				<ul class="ca-record-list">
					<li>{{ 'Compliance_Assessment.Data_Protection_Group_Results' | translate }}</li>
					<li>{{ 'Compliance_Assessment.Data_Protection_Small_Groups' | translate }}</li>
					<li>{{ 'Compliance_Assessment.Data_Protection_Action_Documents' | translate }}</li>
				</ul>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Training_Support' | translate }}</h2></div>
				<ul class="ca-record-list">
					<li><b>{{ 'Compliance_Assessment.Managers' | translate }}:</b> {{ 'Compliance_Assessment.Training_Managers_Text' | translate }}</li>
					<li><b>{{ 'Compliance_Assessment.Employees' | translate }}:</b> {{ 'Compliance_Assessment.Training_Employees_Text' | translate }}</li>
				</ul>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Record_Section_Monitoring_Review' | translate }}</h2></div>
				<p class="ca-small ca-muted">{{ 'Compliance_Assessment.Next_Review' | translate }}: {{ vm.nextReviewDate() | date:'dd MMM yyyy' }} · {{ 'Compliance_Assessment.Next_Annual_Assessment' | translate }}: {{ vm.nextAnnualAssessmentDate() | date:'dd MMM yyyy' }}.</p>
				<table class="ca-table">
					<thead><tr><th>{{ 'Compliance_Assessment.Reviewer' | translate }}</th><th>{{ 'Compliance_Assessment.Date' | translate }}</th><th>{{ 'Compliance_Assessment.Reviewed' | translate }}</th></tr></thead>
					<tbody>
						<tr><td>{{ 'Compliance_Assessment.Worker_Representative' | translate }}</td><td>{{ vm.nextReviewDate() | date:'dd MMM yyyy' }}</td><td>{{ vm.readinessStateLabel(vm.workerRepReadinessRow()?.state) }}</td></tr>
					</tbody>
				</table>
			</div>

			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;">
					<h2>{{ 'Compliance_Assessment.Record_Section_Full_Ai_Report' | translate }}</h2>
				</div>
					<div style="min-height:120px; position:relative;">
						<div *ngIf="!vm.complianceAiRecommendations && !vm.complianceAiRecommendationsLoading">
							<p class="ca-small ca-muted" style="margin-top:-6px;">{{ 'Compliance_Assessment.Generate_Full_Ai_Report_Hint' | translate }}</p>
							<label class="ca-small ca-muted" for="managementSummary" style="display:block;margin-top:12px;">{{ 'Compliance_Assessment.Management_Summary' | translate }}</label>
						<textarea
							id="managementSummary"
							class="ca-textarea"
							rows="4"
							style="margin-top:6px; min-height:96px;"
							[(ngModel)]="vm.reportNarrative"
							(ngModelChange)="vm.saveReportNarrative()"
							[placeholder]="'Compliance_Assessment.Management_Summary_Placeholder' | translate"></textarea>
							<div class="ca-footer-actions">
								<button type="button" class="ca-btn ca-btn-primary" (click)="vm.generateFullAiReport()" [disabled]="vm.complianceAiRecommendationsPending">{{ 'Compliance_Assessment.Generate_Full_Ai_Report' | translate }}</button>
							</div>
							</div>
							<div *ngIf="vm.complianceAiRecommendations && !vm.complianceAiRecommendationsLoading">
								<div class="ca-report-lede" style="white-space:pre-wrap;">{{ vm.complianceAiRecommendations }}</div>
							</div>
							<p class="ca-small" style="color:var(--critical); margin:0;" *ngIf="vm.complianceAiRecommendationsError && !vm.complianceAiRecommendationsLoading">{{ 'Compliance_Assessment.Ai_Report_Error' | translate }}</p>
							<p class="ca-small ca-muted" style="margin:0;" *ngIf="vm.complianceAiRecommendationsDelayed">{{ 'Compliance_Assessment.Ai_Report_Generating_Background' | translate }}</p>
							<loader-overlay *ngIf="vm.complianceAiRecommendationsLoading"></loader-overlay>
						</div>
				</div>
		</div>

		<div class="ca-record-wrap" *ngIf="!vm.actionPlanOnly && vm.resultsViewMode === 'report'">
			<div class="ca-footer-actions" style="margin:0 0 14px;">
				<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" (click)="vm.back()">{{ 'Compliance_Assessment.Back_To_Record' | translate }}</button>
				<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" (click)="vm.printPage()">{{ 'Compliance_Assessment.Print_Save_Pdf' | translate }}</button>
			</div>
			<div class="ca-record-hero">
				<div class="ca-small" style="opacity:.9;">{{ 'Compliance_Assessment.Psychosocial_Analysis' | translate }}</div>
				<h1 class="ca-title" style="margin-top:10px;">{{ 'Compliance_Assessment.Report_Title' | translate }}</h1>
				<p style="opacity:.92;margin:6px 0 0;">{{ vm.summary?.survey?.groupName || ('Compliance_Assessment.The_Organisation' | translate) }} · {{ vm.assessmentDate() | date:'dd MMM yyyy' }} · {{ 'Compliance_Assessment.Completed' | translate }}</p>
			</div>
			<div class="ca-banner info" style="margin-top:14px;">
				<div>{{ 'Compliance_Assessment.Ai_Report_Disclaimer' | translate }}</div>
			</div>
				<div class="ca-card ca-pad ca-record-section">
					<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Executive_Summary' | translate }}</h2></div>
					<p class="ca-report-lede" style="white-space:pre-wrap;" *ngIf="vm.reportNarrative">{{ vm.reportNarrative }}</p>
					<div style="position:relative; min-height:80px;">
						<div class="ca-report-lede" style="white-space:pre-wrap;" *ngIf="vm.aiReportSection('executive') && !vm.complianceAiRecommendationsLoading" [innerHTML]="vm.aiReportSection('executive') | markdownBold"></div>
						<p class="ca-report-lede" *ngIf="!vm.aiReportSection('executive')">{{ vm.reportSummary() }}</p>
						<p class="ca-small ca-muted" style="margin:8px 0 0;" *ngIf="vm.complianceAiRecommendationsLoading">{{ 'Compliance_Assessment.Ai_Executive_Summary_Generating' | translate }}</p>
						<p class="ca-small" style="color:var(--critical); margin:8px 0 0;" *ngIf="vm.complianceAiRecommendationsError && !vm.complianceAiRecommendationsLoading">{{ 'Compliance_Assessment.Ai_Executive_Summary_Error' | translate }}</p>
					</div>
				<div class="ca-summary-grid" style="margin-top:14px;">
					<div><div class="k">{{ 'Compliance_Assessment.Method' | translate }}</div><b>{{ 'Compliance_Assessment.Method_Copsoq_Digital_Short' | translate }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Anonymity' | translate }}</div><b>{{ 'Compliance_Assessment.Group_Results_Only' | translate }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Reportable_Rows' | translate }}</div><b>{{ vm.reportableRows || 0 }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Actions_Assigned' | translate }}</div><b>{{ vm.includedActions().length }}</b></div>
				</div>
			</div>
			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Legal_Basis' | translate }}</h2></div>
				<table class="ca-table">
					<tbody>
						<tr *ngFor="let row of vm.legalBasisRows()">
							<td style="white-space:nowrap;"><b>{{ row.titleKey | translate }}</b></td>
							<td>{{ row.textKey | translate }}</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Methodology' | translate }}</h2></div>
				<div class="ca-summary-grid">
					<div><div class="k">{{ 'Compliance_Assessment.Instrument' | translate }}</div><b>{{ 'Compliance_Assessment.Method_Copsoq_Digital_Short' | translate }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Reference' | translate }}</div><b>{{ 'Compliance_Assessment.Working_Population_Reference' | translate }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Scoring' | translate }}</div><b>{{ 'Compliance_Assessment.Scoring_Benchmark_Text' | translate }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Anonymity_Data_Protection' | translate }}</div><b>{{ 'Compliance_Assessment.Group_Results_Only' | translate }}</b></div>
				</div>
				<p class="ca-small ca-muted" style="margin-top:8px;">{{ 'Compliance_Assessment.Small_Groups_Suppressed_Text' | translate }}</p>
			</div>
			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Participation' | translate }}</h2></div>
				<p>{{ vm.reportCredibilitySentence() }}</p>
				<p>{{ 'Compliance_Assessment.Worker_Consultation_Status_Text' | translate }}: {{ vm.workerConsultationLabel() }}.</p>
			</div>
			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Risk_Results' | translate }}</h2></div>
				<table class="ca-table">
					<thead><tr><th>{{ 'Compliance_Assessment.Risk_Area' | translate }}</th><th>{{ 'Compliance_Assessment.Company' | translate }}</th><th>{{ 'Compliance_Assessment.Reference' | translate }}</th><th>{{ 'Compliance_Assessment.Status' | translate }}</th></tr></thead>
					<tbody>
						<tr *ngFor="let risk of vm.risks">
							<td><b>{{ risk.nameKey | translate }}</b><small style="display:block;" class="ca-muted">{{ risk.descKey | translate }}</small></td>
							<td>{{ vm.scoreLabel(risk) }}</td>
							<td>{{ vm.referenceLabel(risk) }}</td>
							<td><span class="ca-rl" [ngClass]="vm.riskClass(risk.riskLevel)">{{ vm.riskLevelLabel(risk.riskLevel) | translate }}</span></td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="ca-card ca-pad ca-record-section">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Differentiated_Analysis' | translate }}</h2></div>
				<p>{{ 'Compliance_Assessment.Differentiated_Analysis_Report_Text' | translate }}: {{ vm.teamParticipationInline() }}.</p>
				<p class="ca-small ca-muted">{{ 'Compliance_Assessment.Differentiated_Analysis_Report_Hint' | translate }}</p>
			</div>
				<div class="ca-card ca-pad ca-record-section">
					<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Risk_Analysis_Actions' | translate }}</h2></div>
					<p class="ca-small ca-muted" style="margin-top:-6px;">{{ 'Compliance_Assessment.Risk_Analysis_Actions_Hint' | translate }}</p>
					<div class="ca-report-lede" style="white-space:pre-wrap;" *ngIf="vm.aiReportSection('riskActions'); else riskActionsFallback" [innerHTML]="vm.aiReportSection('riskActions') | markdownBold"></div>
					<ng-template #riskActionsFallback>
						<div style="margin:14px 0;" *ngFor="let risk of vm.priorities; let i = index">
							<h3 style="margin:0 0 6px;">7.{{ i + 1 }} {{ risk.nameKey ? (risk.nameKey | translate) : vm.riskDisplayName(risk) }} <span class="ca-rl" [ngClass]="vm.riskClass(risk.riskLevel)">{{ vm.riskLevelLabel(risk.riskLevel) | translate }}</span></h3>
							<p><b>{{ 'Compliance_Assessment.Findings' | translate }}.</b> {{ vm.riskFinding(risk) }}</p>
							<div class="ca-track-card" *ngFor="let action of vm.actionsForRisk(risk)">
								<div class="ca-track-title">
									<button type="button" *ngIf="vm.canOpenActionDetails(action); else reportPlainControl" class="ca-link-button completed" (click)="vm.openActionDetail(action)">
										{{ vm.actionTitle(action) }}
									</button>
									<ng-template #reportPlainControl>{{ vm.actionTitle(action) }}</ng-template>
									<span class="ca-rl" [ngClass]="action.done ? 'low' : 'na'">{{ (action.done ? 'Compliance_Assessment.Done' : 'Compliance_Assessment.In_Progress') | translate }}</span>
								</div>
								<div class="ca-track-meta">
									<span>{{ 'Compliance_Assessment.Owner' | translate }}: {{ vm.employeeName(action.owner) || ('Compliance_Assessment.TBC' | translate) }}</span>
									<span>{{ 'Compliance_Assessment.Due' | translate }}: {{ action.cutOffDate | date:'dd MMM yyyy' }}</span>
									<span>{{ 'Compliance_Assessment.Success' | translate }}: {{ action.successIndicator || ('Compliance_Assessment.Success_Risk_Score_Improves' | translate) }}</span>
								</div>
								<p class="ca-small" style="margin:8px 0 0;">{{ action.progressNote || action.ownerInput || ('Compliance_Assessment.No_Progress_Note' | translate) }}</p>
								<p class="ca-small ca-muted" *ngIf="vm.actionDocuments(action).length">{{ 'Compliance_Assessment.Documents' | translate }}:
									<span *ngFor="let document of vm.actionDocuments(action); let last = last">
										<button type="button" class="ca-link-button" *ngIf="document.id" (click)="vm.downloadActionDocument(action, document)">{{ vm.documentDisplayName(document) }}</button><span *ngIf="!document.id">{{ vm.documentDisplayName(document) }}</span>{{ last ? '' : ', ' }}
									</span>
								</p>
							</div>
						</div>
						<p class="ca-muted" *ngIf="!vm.priorities?.length">{{ 'Compliance_Assessment.No_Control_Selected' | translate }}</p>
					</ng-template>
				</div>
				<div class="ca-card ca-pad ca-record-section">
					<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Communication_Training' | translate }}</h2></div>
					<div class="ca-report-lede" style="white-space:pre-wrap;" *ngIf="vm.aiReportSection('communication'); else communicationFallback" [innerHTML]="vm.aiReportSection('communication') | markdownBold"></div>
					<ng-template #communicationFallback>
						<p><b>{{ 'Compliance_Assessment.Communication' | translate }}.</b> {{ 'Compliance_Assessment.Communication_Report_Text' | translate }}</p>
						<p><b>{{ 'Compliance_Assessment.Training_Support' | translate }}.</b> {{ 'Compliance_Assessment.Training_Support_Report_Text' | translate }}</p>
					</ng-template>
				</div>
				<div class="ca-card ca-pad ca-record-section">
					<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Monitoring_Review' | translate }}</h2></div>
					<div class="ca-report-lede" style="white-space:pre-wrap;" *ngIf="vm.aiReportSection('monitoring'); else monitoringFallback" [innerHTML]="vm.aiReportSection('monitoring') | markdownBold"></div>
					<ng-template #monitoringFallback>
						<p class="ca-small ca-muted">{{ 'Compliance_Assessment.Next_Review' | translate }}: {{ vm.nextReviewDate() | date:'dd MMM yyyy' }} · {{ 'Compliance_Assessment.Next_Annual_Assessment' | translate }}: {{ vm.nextAnnualAssessmentDate() | date:'dd MMM yyyy' }}.</p>
						<table class="ca-table" style="margin-top:10px;">
							<tbody>
								<tr *ngFor="let row of vm.readiness"><td>{{ row.labelKey | translate }}</td><td style="text-align:right;">{{ vm.readinessStateLabel(row.state) }}</td></tr>
							</tbody>
						</table>
					</ng-template>
				</div>
				<div class="ca-card ca-pad ca-record-section">
					<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Report_Section_Conclusion' | translate }}</h2></div>
					<div class="ca-report-lede" style="white-space:pre-wrap;" *ngIf="vm.aiReportSection('conclusion'); else conclusionFallback" [innerHTML]="vm.aiReportSection('conclusion') | markdownBold"></div>
					<ng-template #conclusionFallback><p>{{ vm.reportConclusion() }}</p></ng-template>
				</div>
			</div>

		<div class="ca-card ca-pad" style="margin-top:22px;" *ngIf="vm.actionPlanOnly && (!vm.planCompleted || vm.reviewingCompletedPlan)">
			<div class="ca-steps">
				<span class="ca-step" [ngClass]="{'active': vm.planStep === 1}">1 · {{ 'Compliance_Assessment.Priorities_Controls' | translate }}</span>
				<span class="ca-step" [ngClass]="{'active': vm.planStep === 2}">2 · {{ 'Compliance_Assessment.Assign_Approve' | translate }}</span>
			</div>

			<div *ngIf="vm.planStep === 1">
				<div class="ca-banner info">
					<div><b>{{ 'Compliance_Assessment.Step1_Title' | translate }}</b><br>{{ 'Compliance_Assessment.Moderate_High_Critical_Preselected' | translate }}</div>
				</div>
				<div *ngFor="let risk of vm.priorities" class="ca-risk-block" [ngClass]="{'excluded': !risk.included}">
					<div class="ca-risk-block-head">
						<div class="ca-risk-block-title">
							<h3 style="margin:0;">{{ risk.nameKey ? (risk.nameKey | translate) : vm.riskDisplayName(risk) }}</h3>
							<span class="ca-rl" [ngClass]="vm.riskClass(risk.riskLevel)">{{ vm.riskLevelLabel(risk.riskLevel) | translate }}</span>
						</div>
						<label class="ca-chip ca-chip-brand" style="cursor:pointer;">
							<input type="checkbox" [checked]="risk.included" (change)="vm.togglePriority(risk)" style="margin-right:6px;"> {{ 'Compliance_Assessment.Include' | translate }}
						</label>
					</div>
					<div class="ca-risk-block-body">
						<div class="ca-scope-label">{{ 'Compliance_Assessment.Organisational_Controls' | translate }}</div>
						<div class="ca-controls">
							<label class="ca-control" *ngFor="let action of vm.orgControlsForRisk(risk)" [ngClass]="{'included': action.included}">
								<input type="checkbox" [checked]="action.included" (change)="vm.toggleControl(action)" [disabled]="!risk.included">
								<span>
									<b>{{ vm.actionTitle(action) }}</b>
									<span class="ca-chip ca-chip-brand" style="margin-left:6px;">{{ vm.controlScopeLabel(action) }}</span>
									<div class="ca-small ca-muted" style="margin-top:4px;">{{ vm.actionDescription(action) }}</div>
								</span>
							</label>
						</div>
						<div class="ca-scope-label" *ngIf="vm.individualControlsForRisk(risk).length">{{ 'Compliance_Assessment.Individual_Support' | translate }}</div>
						<div class="ca-controls" *ngIf="vm.individualControlsForRisk(risk).length">
							<label class="ca-control" *ngFor="let action of vm.individualControlsForRisk(risk)" [ngClass]="{'included': action.included}">
								<input type="checkbox" [checked]="action.included" (change)="vm.toggleControl(action)" [disabled]="!risk.included">
								<span>
									<b>{{ vm.actionTitle(action) }}</b>
									<span class="ca-chip" style="margin-left:6px;">{{ 'Compliance_Assessment.Individual' | translate }}</span>
									<div class="ca-small ca-muted" style="margin-top:4px;">{{ vm.actionDescription(action) }}</div>
								</span>
							</label>
						</div>
						<div class="ca-custom-add">
							<input class="ca-input" [(ngModel)]="risk.customControlTitle" [disabled]="!risk.included" [placeholder]="'Compliance_Assessment.Add_Custom_Control_Placeholder' | translate">
							<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" (click)="vm.addCustomControl(risk)" [disabled]="!risk.included">{{ 'Compliance_Assessment.Add' | translate }}</button>
						</div>
						<div class="ca-need-note" *ngIf="risk.customControlMissing">{{ 'Compliance_Assessment.Type_Control_First' | translate }}</div>
						<div class="ca-need-note" *ngIf="vm.riskHasMissingControl(risk)">{{ 'Compliance_Assessment.Choose_One_Control_For_Risk' | translate }}</div>
					</div>
				</div>
				<div class="ca-banner warn" *ngIf="vm.planErrorKey">{{ vm.planErrorKey | translate }}</div>
				<div style="display:flex; justify-content:space-between; gap:10px; margin-top:14px;">
					<button type="button" class="ca-btn ca-btn-ghost" (click)="vm.back()">{{ 'Common.Back' | translate }}</button>
					<button type="button" class="ca-btn ca-btn-primary" (click)="vm.goToAssign()" [disabled]="!vm.priorities?.length">{{ 'Compliance_Assessment.Assign_Approve' | translate }}</button>
				</div>
			</div>

			<div *ngIf="vm.planStep === 2">
				<div class="ca-banner info">
					<div><b>{{ 'Compliance_Assessment.Step2_Title' | translate }}</b><br>{{ 'Compliance_Assessment.Step2_Message' | translate }}</div>
				</div>
				<div class="ca-action-grid ca-action-head ca-muted ca-small">
					<div>{{ 'Compliance_Assessment.Control' | translate }}</div>
					<div>{{ 'Compliance_Assessment.Owner' | translate }}</div>
					<div>{{ 'Compliance_Assessment.Due_Date' | translate }}</div>
					<div class="ca-action-status-cell">{{ 'Compliance_Assessment.Status' | translate }}</div>
				</div>
				<div class="ca-action-grid" *ngFor="let action of vm.selectedActionList" [ngClass]="{'missing': action.validationMissing}">
					<div>
						<button type="button" *ngIf="vm.canOpenActionDetails(action); else assignPlainControl" class="ca-link-button completed" (click)="vm.openActionDetail(action)">
							{{ vm.actionTitle(action) }}
						</button>
						<ng-template #assignPlainControl><b>{{ vm.actionTitle(action) }}</b></ng-template>
						<div class="ca-small ca-muted">{{ action.riskArea }}</div>
					</div>
					<div class="ca-owner">
						<input class="ca-input" [(ngModel)]="action.ownerSearch" [placeholder]="'Compliance_Assessment.Search_Employee' | translate" (focus)="vm.openOwnerPickerKey = action.controlKey" (input)="vm.openOwnerPickerKey = action.controlKey; action.validationMissing = false">
						<div class="ca-owner-menu" *ngIf="vm.openOwnerPickerKey === action.controlKey">
							<div class="ca-owner-option" *ngFor="let employee of vm.filteredEmployees(action)" (mousedown)="vm.selectOwner(action, employee)">
								<b>{{ vm.employeeName(employee) }}</b>
								<div class="ca-small ca-muted">{{ employee.email }}</div>
							</div>
							<div class="ca-owner-option ca-muted" *ngIf="!vm.filteredEmployees(action).length">{{ 'Compliance_Assessment.No_Employees_Found' | translate }}</div>
						</div>
					</div>
					<div>
						<input class="ca-input" type="date" [(ngModel)]="action.cutOffDate" (ngModelChange)="action.validationMissing = false">
					</div>
					<div class="ca-action-status-cell">
						<span class="ca-rl" [ngClass]="vm.actionStatus(action).className">{{ vm.actionStatus(action).labelKey | translate }}</span>
					</div>
				</div>
				<div class="ca-card ca-pad ca-assignment-log" *ngIf="vm.shouldShowInvitationSendStage()">
					<div class="ca-section-title" style="margin-top:0;">
						<h2>{{ 'Compliance_Assessment.Assignment_Emails' | translate }}</h2>
						<span class="ca-chip ca-chip-brand">{{ vm.assignmentRowList.length }} {{ (vm.assignmentRowList.length === 1 ? 'Compliance_Assessment.Employee' : 'Compliance_Assessment.Employees') | translate }}</span>
					</div>
					<p class="ca-small ca-muted" style="margin-top:-6px;">{{ 'Compliance_Assessment.Assignment_Emails_Hint' | translate }}</p>
					<table class="ca-table ca-assignment-table" *ngIf="vm.assignmentRowList.length">
						<thead>
							<tr><th>{{ 'Compliance_Assessment.Employee' | translate }}</th><th>{{ 'Compliance_Assessment.Control' | translate }}</th><th>{{ 'Compliance_Assessment.Due' | translate }}</th><th>{{ 'Compliance_Assessment.Status' | translate }}</th></tr>
						</thead>
						<tbody>
							<tr *ngFor="let row of vm.assignmentRowList">
								<td><b>{{ row.employeeName }}</b><small style="display:block;" class="ca-muted">{{ row.email }} · {{ 'Compliance_Assessment.Employee' | translate }}</small></td>
								<td>
									<button type="button" *ngIf="vm.canOpenActionDetails(row.action); else assignmentPlainControl" class="ca-link-button completed" (click)="vm.openActionDetail(row.action)">
										{{ row.title }}
									</button>
									<ng-template #assignmentPlainControl>{{ row.title }}</ng-template>
									<small style="display:block;" class="ca-muted">{{ row.riskArea }}</small>
								</td>
								<td>{{ row.dueDate ? (row.dueDate | date:'dd.MM.yyyy') : ('Compliance_Assessment.TBC' | translate) }}</td>
								<td class="ca-action-status-cell">
									<span class="ca-rl" [ngClass]="row.link ? 'low' : 'na'">{{ vm.assignmentStatusLabel(row) }}</span>
								</td>
							</tr>
						</tbody>
					</table>
					<p class="ca-muted ca-small" *ngIf="!vm.assignmentRowList.length">{{ 'Compliance_Assessment.No_Assignment_Rows' | translate }}</p>
				</div>
				<div class="ca-banner warn" *ngIf="vm.planErrorText">{{ vm.planErrorText | translate }}</div>
				<div class="ca-review-gate">
					<h3 class="ca-review-title">{{ 'Compliance_Assessment.Review_Approve' | translate }}</h3>
					<p class="ca-review-message">
						<ng-container *ngIf="vm.shouldShowInvitationSendStage()">
							{{ 'Compliance_Assessment.Assign_Send_Invitations_Message' | translate }}
							<b *ngIf="vm.pendingInvitationCount()"> {{ vm.pendingInvitationCount() }}</b><ng-container *ngIf="vm.pendingInvitationCount()"> {{ 'Compliance_Assessment.Owners_Selected_Not_Notified' | translate }}</ng-container>
						</ng-container>
						<ng-container *ngIf="!vm.shouldShowInvitationSendStage()">
							{{ 'Compliance_Assessment.Invitations_Sent_To' | translate }} <b>{{ vm.sentInvitationCount() }}</b> {{ 'Compliance_Assessment.Owners_Review_Inputs_Message' | translate }}
						</ng-container>
					</p>
					<div class="ca-review-check" *ngIf="!vm.shouldShowInvitationSendStage()">
						<input id="workerRepReviewedCheckbox" type="checkbox" [(ngModel)]="vm.workerRep.consulted" (ngModelChange)="vm.saveWorkerRepReview($event)">
						<div class="ca-review-check-body">
							<label for="workerRepReviewedCheckbox"><b>{{ 'Compliance_Assessment.Worker_Representative_Reviewed_Label' | translate }}</b> {{ 'Compliance_Assessment.Worker_Representative_Reviewed_Hint' | translate }}</label>
							<input class="ca-input" [(ngModel)]="vm.workerRep.name" (ngModelChange)="vm.saveWorkerRepReview()" [placeholder]="'Compliance_Assessment.Worker_Representative_Name_Optional' | translate">
						</div>
					</div>
					<p class="ca-review-message" *ngIf="vm.shouldShowInvitationSendStage()">{{ 'Compliance_Assessment.Sign_Off_Date_Hint' | translate }} ({{ vm.latestControlDueDate() | date:'dd MMM yyyy' }}).</p>
					<div style="display:flex; justify-content:flex-start; gap:10px; flex-wrap:wrap; margin-top:14px;">
						<button type="button" class="ca-btn ca-btn-ghost" (click)="vm.back()">{{ 'Common.Back' | translate }}</button>
						<button type="button" class="ca-btn ca-btn-primary" *ngIf="vm.shouldShowInvitationSendStage()" (click)="vm.confirmAssignmentsAndSendInvitations()" [disabled]="vm.completingPlan">{{ (vm.completingPlan ? 'Compliance_Assessment.Sending' : 'Compliance_Assessment.Confirm_Assignments_Send_Invitations') | translate }}</button>
						<button type="button" class="ca-btn ca-btn-primary" *ngIf="!vm.shouldShowInvitationSendStage()" (click)="vm.acceptActionPlan()" [disabled]="vm.completingPlan">{{ 'Compliance_Assessment.Review_Accept_Generate_Compliance_Report' | translate }}</button>
					</div>
					<p class="ca-small" style="margin:8px 0 0;">{{ (vm.shouldShowInvitationSendStage() ? 'Compliance_Assessment.Confirm_Assignments_Send_Invitations_Hint' : 'Compliance_Assessment.Review_Accept_Generate_Compliance_Report_Hint') | translate }}</p>
				</div>
			</div>
		</div>

		<div class="ca-complete-wrap" *ngIf="vm.actionPlanOnly && vm.planCompleted && !vm.reviewingCompletedPlan">
			<div class="ca-complete-hero">
				<div style="font-size:2.2rem;">✓</div>
				<h1 class="ca-title">{{ 'Compliance_Assessment.Assessment_Completed' | translate }}</h1>
				<p class="ca-muted" style="margin-top:6px;">{{ vm.summary?.survey?.groupName || 'Northwind' }} · {{ 'Compliance_Assessment.Psr_Title' | translate }} {{ vm.assessmentYear() }}</p>
			</div>
			<div class="ca-card ca-pad" style="margin-bottom:16px;">
				<div class="ca-section-title" style="margin-top:0;"><h2>{{ 'Compliance_Assessment.Summary' | translate }}</h2></div>
				<div class="ca-summary-grid">
					<div><div class="k">{{ 'Compliance_Assessment.Assessment_Date' | translate }}</div><b>{{ vm.assessmentDate() | date:'dd MMM yyyy' }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Response_Rate' | translate }}</div><b>{{ vm.responseRate }}% ({{ vm.respondedCount || 0 }}/{{ vm.sentCount || 0 }})</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Priority_Risks_Selected' | translate }}</div><b>{{ vm.priorities?.length || 0 }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Actions_Assigned' | translate }}</div><b>{{ vm.includedActions().length }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Next_Review_Date' | translate }}</div><b>{{ vm.nextReviewDate() | date:'dd MMM yyyy' }}</b></div>
					<div><div class="k">{{ 'Compliance_Assessment.Next_Annual_Assessment' | translate }}</div><b>{{ vm.nextAnnualAssessmentDate() | date:'dd MMM yyyy' }}</b></div>
				</div>
			</div>
			<div class="ca-card ca-pad">
				<div class="ca-section-title" style="margin-top:0;">
					<h2>{{ 'Compliance_Assessment.Action_Tracking' | translate }}</h2>
					<span class="ca-chip ca-chip-brand">{{ vm.actionDoneCount() }} / {{ vm.includedActions().length }} {{ 'Compliance_Assessment.Done' | translate }}</span>
				</div>
				<p class="ca-small ca-muted ca-track-help">{{ 'Compliance_Assessment.Action_Tracking_Hint' | translate }}</p>
				<div class="ca-track-card" *ngFor="let action of vm.includedActions()" [ngClass]="{'done': action.done}">
					<div class="ca-track-head">
						<div style="min-width:0;">
							<div class="ca-track-title">
								<button type="button" *ngIf="vm.canOpenActionDetails(action); else trackingPlainControl" class="ca-link-button completed" (click)="vm.openActionDetail(action)">
									{{ vm.actionTitle(action) }}
								</button>
								<ng-template #trackingPlainControl>{{ vm.actionTitle(action) }}</ng-template>
							</div>
							<div class="ca-track-meta">
								<span>{{ action.riskArea }}</span>
								<span>{{ vm.employeeName(action.owner) }}<ng-container *ngIf="vm.employeeRole(action.owner)"> · {{ vm.employeeRole(action.owner) }}</ng-container></span>
								<span>{{ 'Compliance_Assessment.Due' | translate }} {{ action.cutOffDate | date:'dd MMM yyyy' }}</span>
							</div>
						</div>
						<div class="ca-track-status">
							<label class="ca-done-toggle"><input type="checkbox" [disabled]="action.saving || action.uploading" [checked]="action.done" (change)="vm.toggleActionDone(action, $event)"> {{ 'Compliance_Assessment.Mark_Done' | translate }}</label>
						</div>
					</div>
					<textarea class="ca-textarea" style="margin-top:12px;" [(ngModel)]="action.progressNote" [placeholder]="'Compliance_Assessment.Progress_Note_Placeholder' | translate"></textarea>
					<div style="margin-top:10px; display:flex; gap:8px; align-items:center; flex-wrap:wrap;">
						<label class="ca-doc-input">
							<input type="file" [disabled]="action.saving || action.uploading" multiple (change)="vm.addTrackingDocuments(action, $event)">
							{{ 'Compliance_Assessment.Attach_Documents' | translate }}
						</label>
						<span class="ca-doc-chip" *ngFor="let document of vm.actionDocuments(action)">
							<button type="button" class="ca-link-button" *ngIf="document.id" (click)="vm.downloadActionDocument(action, document)">{{ vm.documentDisplayName(document) }}</button><span *ngIf="!document.id">{{ vm.documentDisplayName(document) }}</span>
							<button type="button" [disabled]="action.saving || action.uploading" (click)="vm.removeTrackingDocument(action, document)" [attr.aria-label]="'Compliance_Assessment.Remove_Document' | translate">×</button>
						</span>
						<button type="button" class="ca-btn ca-btn-ghost ca-btn-sm" (click)="vm.saveTrackingNote(action)" [disabled]="action.saving || action.uploading">{{ 'Compliance_Assessment.Save_Note' | translate }}</button>
						<span class="ca-small ca-muted" role="status" *ngIf="action.uploading">{{ 'Toolkit.Common.Loading' | translate }}</span>
						<span class="ca-small ca-muted" *ngIf="action.noteSaved && !action.uploading">{{ 'Compliance_Assessment.Saved' | translate }}</span>
					</div>
				</div>
				</div>
				<div class="ca-footer-actions">
					<button type="button" class="ca-btn ca-btn-primary" (click)="vm.saveAllTracking()" [disabled]="vm.savingAllTracking">{{ 'Common.Save' | translate }}</button>
					<button type="button" class="ca-btn ca-btn-ghost" (click)="vm.refreshTracking()">{{ 'Compliance_Assessment.Refresh_Contributions' | translate }}</button>
					<button type="button" class="ca-btn ca-btn-ghost" (click)="vm.viewComplianceRecord()">{{ 'Compliance_Assessment.View_Compliance_Record' | translate }}</button>
					<button type="button" class="ca-btn ca-btn-ghost" (click)="vm.printPage()">{{ 'Compliance_Assessment.Print_Save_Pdf' | translate }}</button>
					<button type="button" class="ca-btn ca-btn-ghost" (click)="vm.returnToDashboard()">{{ 'Compliance_Assessment.Return_To_Dashboard' | translate }}</button>
				</div>
				<div class="ca-toast" *ngIf="vm.trackingSavedToast">{{ 'Compliance_Assessment.Saved' | translate }}</div>
				<div id="complianceRecord" class="ca-card ca-pad" style="margin-top:16px;" *ngIf="vm.showComplianceRecord">
				<div class="ca-section-title" style="margin-top:0;">
					<h2>{{ 'Compliance_Assessment.Compliance_Record' | translate }}</h2>
					<span class="ca-chip ca-chip-brand">{{ 'Compliance_Assessment.Completed' | translate }}</span>
				</div>
				<p class="ca-small ca-muted">{{ vm.summary?.survey?.groupName || 'Northwind' }} · {{ 'Compliance_Assessment.Psr_Title' | translate }} {{ vm.assessmentYear() }} · {{ vm.assessmentDate() | date:'dd MMM yyyy' }}</p>
				<table class="ca-table" style="margin-top:12px;">
					<thead>
						<tr><th>{{ 'Compliance_Assessment.Control' | translate }}</th><th>{{ 'Compliance_Assessment.Owner' | translate }}</th><th>{{ 'Compliance_Assessment.Due' | translate }}</th><th>{{ 'Compliance_Assessment.Implementation' | translate }}</th><th>{{ 'Compliance_Assessment.Documents' | translate }}</th></tr>
					</thead>
					<tbody>
						<tr *ngFor="let action of vm.includedActions()">
							<td>
								<button type="button" *ngIf="vm.canOpenActionDetails(action); else completePlainControl" class="ca-link-button completed" (click)="vm.openActionDetail(action)">
									{{ vm.actionTitle(action) }}
								</button>
								<ng-template #completePlainControl><b>{{ vm.actionTitle(action) }}</b></ng-template>
								<small style="display:block;" class="ca-muted">{{ action.riskArea }}</small>
							</td>
							<td>{{ vm.employeeName(action.owner) || ('Compliance_Assessment.TBC' | translate) }}</td>
							<td>{{ action.cutOffDate | date:'dd MMM yyyy' }}</td>
							<td>{{ action.progressNote || action.ownerInput || ('Compliance_Assessment.Not_Recorded' | translate) }}</td>
							<td>
								<span *ngIf="!vm.actionDocuments(action).length">{{ 'Compliance_Assessment.None' | translate }}</span>
								<span *ngFor="let document of vm.actionDocuments(action); let last = last">
									<button type="button" class="ca-link-button" *ngIf="document.id" (click)="vm.downloadActionDocument(action, document)">{{ vm.documentDisplayName(document) }}</button><span *ngIf="!document.id">{{ vm.documentDisplayName(document) }}</span>{{ last ? '' : ', ' }}
								</span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<div class="ca-modal-backdrop center" *ngIf="vm.selectedActionDetail" (click)="vm.closeActionDetail()">
			<div class="ca-modal-panel" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
				<div class="ca-modal-head">
					<div>
						<h3>{{ vm.actionTitle(vm.selectedActionDetail) }}</h3>
						<div class="ca-small ca-muted" style="margin-top:4px;">{{ vm.selectedActionDetail.riskArea }}</div>
					</div>
					<button type="button" class="ca-close" (click)="vm.closeActionDetail()">×</button>
				</div>
				<div class="ca-modal-body">
					<div class="ca-detail-grid">
						<div>
							<div class="ca-detail-label">{{ 'Compliance_Assessment.Risk_Area' | translate }}</div>
							<div class="ca-detail-value">{{ vm.selectedActionDetail.riskArea || ('Compliance_Assessment.Risk_Area' | translate) }}</div>
						</div>
						<div>
							<div class="ca-detail-label">{{ 'Compliance_Assessment.Owner' | translate }}</div>
							<div class="ca-detail-value">
								{{ vm.employeeName(vm.selectedActionDetail.owner) || ('Compliance_Assessment.TBC' | translate) }}
								<ng-container *ngIf="vm.employeeRole(vm.selectedActionDetail.owner)"> · {{ vm.employeeRole(vm.selectedActionDetail.owner) }}</ng-container>
							</div>
						</div>
						<div>
							<div class="ca-detail-label">{{ 'Compliance_Assessment.Due_Date' | translate }}</div>
							<div class="ca-detail-value">{{ vm.selectedActionDetail.cutOffDate | date:'dd MMM yyyy' }}</div>
						</div>
						<div>
							<div class="ca-detail-label">{{ 'Compliance_Assessment.Status' | translate }}</div>
							<div class="ca-detail-value"><span class="ca-rl" [ngClass]="vm.actionStatus(vm.selectedActionDetail).className">{{ vm.actionStatus(vm.selectedActionDetail).labelKey | translate }}</span></div>
						</div>
					</div>
					<div class="ca-detail-label">{{ 'Compliance_Assessment.Progress_Note_From_Owner' | translate }}</div>
					<p class="ca-detail-note" *ngIf="vm.actionProgressNote(vm.selectedActionDetail); else noActionNote">{{ vm.actionProgressNote(vm.selectedActionDetail) }}</p>
					<ng-template #noActionNote><p class="ca-detail-note ca-muted">{{ 'Compliance_Assessment.No_Progress_Note' | translate }}</p></ng-template>

					<div class="ca-detail-label">{{ 'Compliance_Assessment.Documents' | translate }}</div>
					<div class="ca-track-row" *ngIf="vm.actionDocuments(vm.selectedActionDetail).length; else noActionDocuments">
						<span class="ca-doc-chip" *ngFor="let document of vm.actionDocuments(vm.selectedActionDetail)"><button type="button" class="ca-link-button" *ngIf="document.id" (click)="vm.downloadActionDocument(vm.selectedActionDetail, document)">{{ vm.documentDisplayName(document) }}</button><span *ngIf="!document.id">{{ vm.documentDisplayName(document) }}</span></span>
					</div>
					<ng-template #noActionDocuments><p class="ca-small ca-muted" style="margin:4px 0 0;">{{ 'Compliance_Assessment.None' | translate }}</p></ng-template>
				</div>
			</div>
		</div>
	</div>
</div>
